export var Labels = {
    paymentOptionDivider: 'atau',
    cardHolderName: 'Nama tertera pada kad',
    cardNumber: 'Nombor Kad',
    cardExpiration: 'Tarikh Tamat Tempoh (MM/YY)',
    cvv: 'CVV',
    continueButton: 'Teruskan'
};
export var FieldErrors = {
    invalidCardHolderName: 'Sila masukkan nama pemegang kad.',
    invalidCreditCardNumber: 'Sila masukkan nombor kad yang sah.',
    invalidCardBrand: 'Sila masukkan nama penyedia kad yang disokong.',
    invalidExpirationDate: 'Sila masukkan tarikh tamat tempoh yang sah.',
    invalidCvv: 'Sila masukkan kod CVV.'
};
